import { useEffect, useState } from 'react';
import { m as motion, AnimatePresence } from 'framer-motion';
import { css, cx, etiColors, mediaQueries } from '@eti/styles';
import fetchCarrierLogo from './utils/carrierLogo';
import { jsx as _jsx } from "react/jsx-runtime";
const sizeStyles = css`
  flex-shrink: 0;
  height: 20px;
  width: 20px;

  @media ${mediaQueries.medium.up} {
    height: 32px;
    width: 32px;
  }

  @media ${mediaQueries.large.up} {
    height: 40px;
    width: 40px;
  }
`;
const placeholderStyles = css`
  background-color: ${etiColors.grayScale[4]};
  border-radius: 3px;
`;
const motionVariantsForLogo = {
  enter: {
    opacity: 1,
    transition: {
      type: 'tween',
      delay: 0.25,
      duration: 0.75
    }
  },
  exit: {
    opacity: 0,
    transition: {
      type: 'tween',
      duration: 0.3
    }
  }
};
const motionVariantsForPlaceholder = {
  initial: {
    opacity: 0
  },
  enter: {
    opacity: 1,
    transition: {
      type: 'tween',
      duration: 0.3
    }
  },
  exit: {
    opacity: 0,
    display: 'none',
    transition: {
      type: 'tween',
      duration: 0.15
    }
  }
};
const CarrierLogo = _ref => {
  let {
    className = sizeStyles,
    'data-testid': dataTestid,
    id,
    imageAlt
  } = _ref;
  const [logo, setLogo] = useState(null);
  useEffect(() => {
    let isUnmounted = false;
    const loadCarrierLogo = async iataCode => {
      const carrierLogo = await fetchCarrierLogo(iataCode);
      if (!isUnmounted) {
        setLogo(carrierLogo);
      }
    };
    loadCarrierLogo(id);
    return () => {
      isUnmounted = true;
    };
  }, [id]);
  return /*#__PURE__*/_jsx(AnimatePresence, {
    children: logo ? /*#__PURE__*/_jsx(motion.img, {
      alt: imageAlt,
      animate: "enter",
      className: className,
      "data-testid": dataTestid,
      exit: "exit",
      initial: "exit",
      src: logo,
      variants: motionVariantsForLogo
    }, `${logo}`) : /*#__PURE__*/_jsx(motion.div, {
      animate: "enter",
      className: cx(className, placeholderStyles),
      "data-testid": `${dataTestid}-no-logo`,
      exit: "exit",
      initial: "initial",
      variants: motionVariantsForPlaceholder
    }, "placeholder")
  });
};
export default CarrierLogo;